import * as Types from './statusActionTypes';

export function receivedData(key) {
  return { type: Types.RECEIVED_DATA, key };
}

export function removedData(key) {
  return { type: Types.REMOVED_DATA, key };
}

export function beginRevisitAssessment(id) {
  return { type: Types.BEGIN_REVISIT_ASSESSMENT, id };
}

export function endRevisitAssessment() {
  return { type: Types.END_REVISIT_ASSESSMENT };
}

export function tokenHasExpired() {
  return { type: Types.TOKEN_HAS_EXPIRED };
}

export function tokenRefreshed() {
  return { type: Types.TOKEN_REFRESHED };
}



// WEBPACK FOOTER //
// ./src/redux/actions/statusActions.js